import { PureComponent } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { CALYPSO, CALYPSO_DARK, GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
import { BUTTON_RADIUS } from 'HubStyleTokens/sizes';
import Big from 'UIComponents/elements/Big';
import UIDropdownCaret from 'UIComponents/dropdown/UIDropdownCaret';
import UISearchInput from 'UIComponents/input/UISearchInput';
import UISelect from 'UIComponents/input/UISelect';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import SearchBarContext from '../context/SearchBarContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const STOREFRONT_SEARCH_BAR_CLASS = 'storefront-search-bar';
export const SearchBarCategorySelect = styled(UISelect).withConfig({
  displayName: "SearchBarInput__SearchBarCategorySelect",
  componentId: "sc-12ocguk-0"
})(["height:100%;display:flex !important;align-items:center !important;padding:0 20px;"]);
const SearchBarCategorySelectBox = styled(UIBox).withConfig({
  displayName: "SearchBarInput__SearchBarCategorySelectBox",
  componentId: "sc-12ocguk-1"
})(["display:flex;align-items:stretch;border-right:1px solid ", ";"], GREAT_WHITE);
const SearchBarCategorySelectCaret = styled(UIDropdownCaret).withConfig({
  displayName: "SearchBarInput__SearchBarCategorySelectCaret",
  componentId: "sc-12ocguk-2"
})(["margin-left:8px;font-size:16px;color:", ";&:hover{color:", ";}"], CALYPSO, CALYPSO_DARK);
const SearchBarCategorySelectValue = ({
  children
}) => /*#__PURE__*/_jsx(Big, {
  weight: "bold",
  children: children
});
export default class SearchBarInput extends PureComponent {
  render() {
    return /*#__PURE__*/_jsx(SearchBarContext.Consumer, {
      children: ({
        categorySelectProps,
        inputSize
      }) => /*#__PURE__*/_jsx("div", {
        style: {
          backgroundColor: OLAF,
          borderRadius: BUTTON_RADIUS
        },
        children: /*#__PURE__*/_jsxs(UIFlex, {
          align: "stretch",
          children: [categorySelectProps && /*#__PURE__*/_jsx(SearchBarCategorySelectBox, {
            grow: 0,
            shrink: 0,
            children: /*#__PURE__*/_jsx(SearchBarCategorySelect, Object.assign({}, categorySelectProps, {
              anchorType: "button",
              buttonUse: "primary-white",
              caretRenderer: SearchBarCategorySelectCaret,
              itemComponent: "div",
              menuWidth: 250,
              searchable: false,
              valueComponent: SearchBarCategorySelectValue
            }))
          }), /*#__PURE__*/_jsx(UISearchInput, Object.assign({}, this.props, {
            className: classNames(STOREFRONT_SEARCH_BAR_CLASS, this.props.className),
            size: inputSize,
            styled: false
          }))]
        })
      })
    });
  }
}